module.exports = __webpack_public_path__ + "img/manda_004.0230f5af.png";